import { render, staticRenderFns } from "./SetupKebijakanWilayahPenjualan.vue?vue&type=template&id=024e7e4a&"
import script from "./SetupKebijakanWilayahPenjualan.vue?vue&type=script&lang=js&"
export * from "./SetupKebijakanWilayahPenjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports